import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiRadio, FiVideo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Header = () => {
  const location = useLocation();
  
  const navigation = [
    { 
      name: 'Radio', 
      fullName: 'Live Radio', 
      href: 'https://s107.radiolize.com/public/appsumo__arqffi_vzkqcc', 
      icon: FiRadio, 
      color: 'bg-orange-50 text-[#F28423]' 
    },
  ];

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-4 md:p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1 items-center">
          <Link to="/" className="-m-1.5 p-1.5 flex items-center gap-2 md:gap-3">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/27e565ca62f331bb3d3ca67ccd492f06cd2fa92619ed72ab1d77f8d98c6e5b4cc6657f2d778fcddfd847ef506ea1c4d1/images/aW1hZ2UvcG5n/0902e344c6041ca9f56ff9415cbb69cb.png" 
              alt="Effekten Logo" 
              className="h-8 w-auto md:h-10" 
            />
            <span className="font-bold text-lg md:text-xl tracking-tight">Effekten Play</span>
          </Link>
        </div>
        
        <div className="flex items-center gap-2 md:gap-6">
          {navigation.map((item) => (
            <a 
              key={item.name} 
              href={item.href} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={`flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-sm font-bold transition-all hover:scale-105 active:scale-95 shadow-sm ${item.color}`}
            >
              <SafeIcon icon={item.icon} className="h-4 w-4" />
              <span className="hidden sm:inline">{item.fullName}</span>
              <span className="sm:hidden">{item.name}</span>
            </a>
          ))}
          
          <Link 
            to="/live" 
            className={`flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-sm font-bold transition-all hover:scale-105 active:scale-95 shadow-sm ${
              location.pathname === '/live' 
                ? 'bg-[#F28423] text-white' 
                : 'bg-purple-50 text-purple-600 hover:bg-purple-100'
            }`}
          >
            <SafeIcon icon={FiVideo} className="h-4 w-4" />
            <span className="hidden sm:inline">Effekten Live</span>
            <span className="sm:hidden">Live</span>
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;